import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../../library/link/link';

import './cms-shopping-categories.scss';

function CmsShoppingCategories(props) {
  const { categories } = props;

  return (
    <div>
      <ul styleName="list">
        {Array.isArray(categories) &&
          categories.map((category, idx) => {
            const { image, link, type } = category || {};
            return (
              <li key={`csc-${idx}`} styleName="category">
                <Link styleName="link" to={link?.href}>
                  <img
                    alt={image?.altText}
                    src={image?.url}
                    styleName="image"
                  />
                  <span styleName="type">{type}</span>
                </Link>
              </li>
            );
          })}
      </ul>
    </div>
  );
}

CmsShoppingCategories.propTypes = {
  categories: PropTypes.array
};

export default CmsShoppingCategories;
